module.exports = __webpack_public_path__ + "static/media/Small multiple violations of the 6.b8f22bcd.png";